import React, { FC } from 'react';
import { Select } from '@workboard/wobo-ui';
import { ActionItemTypeAttributeValues, Icon, useInStateField } from '@workboard/action-item';
import styled from 'styled-components';

const IconEl = styled.span`
  display: inline-block;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 16px 16px;
  svg {
    vertical-align: middle;
  }
`;

interface Props {
  'data-testid'?: string;
  showText?: boolean;
  label: string;
  iconName: string;
}

const StatusIcon: FC<Props> = ({ label, iconName }) => (
  <IconEl title={label} tabindex="0">
    <Icon name={iconName} />
  </IconEl>
);

const IconWrapper = styled.div`
  gap: 4px;
  display: flex;
  align-items: center;
`;

export const AIIcon: FC<Props> = ({
  'data-testid': testId,
  showText,
  label,
  iconName
}) => (
  <IconWrapper data-testid={testId}>
    <StatusIcon label={label} iconName={iconName} />
    {showText ? (
      <>
        &nbsp;<span>{label}</span>
      </>
    ) : null}
  </IconWrapper>
);

interface IProps {
  name: string;
  'data-testid'?: string;
  isDisabled?: boolean;
  helperText?: string;
  isError?: boolean;
  label?: string;
  id?: string;
  onChange(e: React.ChangeEvent, obj: unknown): void;
  value?: string | number;
  style?: any;
  options: ActionItemTypeAttributeValues[];
}

export const InLineStateField: FC<IProps> = ({
  name,
  onChange,
  value,
  label,
  options,
  ...props
}) => {
  const customProps = useInStateField(options, name, value, onChange);
  return (
    <Select
      {...props}
      getOptionLabel={(opt) => opt.label}
      template={(opt: ActionItemTypeAttributeValues) => <AIIcon label={opt.label} iconName={opt.icons?.component} showText />}
      label={label}
      name={name}
      {...customProps}
      options={options}
    />
  );
};
